/**
 * Article Sticky Scroll - Single page scroll with transform-based column movement
 */
(function() {
  'use strict';
  
  if (window.innerWidth < 1025) return;
  
  const heroContainer = document.querySelector('.article-template__hero-container');
  const textWrapper = document.querySelector('.itg-article-text-wrapper');
  const desktopMain = document.querySelector('.itg--article-desk-main');
  
  if (!heroContainer || !textWrapper || !desktopMain) return;
  
  let heroInner = heroContainer.querySelector('.hero-inner-wrapper');
  let textInner = textWrapper.querySelector('.text-inner-wrapper');
  
  if (!heroInner) {
    heroInner = document.createElement('div');
    heroInner.className = 'hero-inner-wrapper';
    while (heroContainer.firstChild) {
      heroInner.appendChild(heroContainer.firstChild);
    }
    heroContainer.appendChild(heroInner);
  }
  
  if (!textInner) {
    textInner = document.createElement('div');
    textInner.className = 'text-inner-wrapper';
    while (textWrapper.firstChild) {
      textInner.appendChild(textWrapper.firstChild);
    }
    textWrapper.appendChild(textInner);
  }
  
  let containerStartOffset = 0;
  let containerScrollHeight = 0;
  let heroMaxScroll = 0;
  let textMaxScroll = 0;
  let isUpdating = false;
  
  function updateMetrics() {
    const headerHeight = 4.05 * 16;
    const viewportHeight = window.innerHeight;
    const columnHeight = viewportHeight - headerHeight;
    
    const heroTransform = heroInner.style.transform;
    const textTransform = textInner.style.transform;
    heroInner.style.transform = '';
    textInner.style.transform = '';
    
    void heroInner.offsetHeight;
    void textInner.offsetHeight;
    
    heroInner.style.paddingBottom = '0';
    heroInner.style.marginBottom = '0';
    
    void heroInner.offsetHeight;
    
    const heroContentHeight = heroInner.scrollHeight;
    const textContentHeight = textInner.scrollHeight;
    
    heroInner.style.transform = heroTransform;
    textInner.style.transform = textTransform;
    
    heroMaxScroll = Math.max(0, heroContentHeight - columnHeight - 25);
    textMaxScroll = Math.max(0, textContentHeight - columnHeight);
    
    const tallestScroll = Math.max(heroMaxScroll, textMaxScroll);
    containerScrollHeight = columnHeight + tallestScroll;
    
    const rect = desktopMain.getBoundingClientRect();
    containerStartOffset = rect.top + window.pageYOffset;
    
    desktopMain.style.height = containerScrollHeight + 'px';
  }
  
  function updateScroll() {
    if (isUpdating) return;
    isUpdating = true;
    
    requestAnimationFrame(() => {
      const rect = desktopMain.getBoundingClientRect();
      const headerHeight = 4.05 * 16;
      const viewportHeight = window.innerHeight;
      const columnHeight = viewportHeight - headerHeight;
      
      const containerTop = rect.top;
      const pageScrollY = window.pageYOffset;
      
      let scrolledPastTop = 0;
      if (pageScrollY > 0 && containerTop <= headerHeight) {
        scrolledPastTop = Math.max(0, headerHeight - containerTop);
      }
      
      const maxScrollDistance = Math.max(heroMaxScroll, textMaxScroll);
      
      let scrollProgress = 0;
      if (maxScrollDistance > 0 && scrolledPastTop > 0) {
        scrollProgress = Math.min(1, Math.max(0, scrolledPastTop / maxScrollDistance));
      }
      
      const expectedHeight = columnHeight + maxScrollDistance;
      if (Math.abs(desktopMain.offsetHeight - expectedHeight) > 1) {
        desktopMain.style.height = expectedHeight + 'px';
      }
      
      if (heroMaxScroll > 0) {
        const heroTranslate = -scrollProgress * heroMaxScroll;
        heroInner.style.transform = `translateY(${heroTranslate}px)`;
      } else {
        heroInner.style.transform = '';
      }
      
      if (textMaxScroll > 0) {
        const textTranslate = -scrollProgress * textMaxScroll;
        textInner.style.transform = `translateY(${textTranslate}px)`;
      } else {
        textInner.style.transform = '';
      }
      
      isUpdating = false;
    });
  }
  
  function handleScroll() {
    updateScroll();
  }
  
  function initScroll() {
    setTimeout(() => {
      const images = heroContainer.querySelectorAll('img');
      let imagesLoaded = 0;
      const totalImages = images.length;
      
      function initializeListeners() {
        updateMetrics();
        updateScroll();
        
        window.addEventListener('scroll', handleScroll, { passive: true });
        
        window.addEventListener('resize', () => {
          setTimeout(() => {
            updateMetrics();
            updateScroll();
          }, 100);
        }, { passive: true });
      }
      
      if (totalImages === 0) {
        initializeListeners();
        return;
      }
      
      images.forEach(img => {
        if (img.complete) {
          imagesLoaded++;
          if (imagesLoaded === totalImages) {
            initializeListeners();
          }
        } else {
          img.addEventListener('load', () => {
            imagesLoaded++;
            if (imagesLoaded === totalImages) {
              initializeListeners();
            }
          });
          img.addEventListener('error', () => {
            imagesLoaded++;
            if (imagesLoaded === totalImages) {
              initializeListeners();
            }
          });
        }
      });
      
      setTimeout(() => {
        initializeListeners();
      }, 1000);
    }, 100);
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScroll);
  } else {
    initScroll();
  }
})();